/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */



function resizeGridItem( item ) {
	const grid = document.getElementsByClassName( "masonry-grid" )[0];
	const rowHeight = parseInt( window.getComputedStyle( grid ).getPropertyValue( 'grid-auto-rows' ) );
	const rowGap = parseInt( window.getComputedStyle( grid ).getPropertyValue( 'grid-row-gap' ) );
	const rowSpan = Math.ceil( ( item.querySelector( '.wp-block-quote' ).getBoundingClientRect().height + rowGap ) / ( rowHeight + rowGap ) );
	item.style.gridRowEnd = "span " + rowSpan;
}

function resizeAllGridItems() {
	const allItems = document.getElementsByClassName( "masonry-grid__item" );
	
	for ( const element of allItems ) {
		resizeGridItem( element );
	}
}

const tabQuote = document.querySelector( ".tab-quotes" );

const observer = new MutationObserver( ( mutations ) => {
	mutations.forEach( ( mutation ) => {
		if ( !mutation.target.hasAttribute( "hidden" ) ) {
			resizeAllGridItems();
		}
	} );
} );
observer.observe( tabQuote, { attributes: true, childList: true, subtree: true } );


if ( 'ResizeObserver' in window ) {
	new ResizeObserver( entries => {
		resizeAllGridItems();
	} ).observe( tabQuote );
}


//

const totalQuotes = tabQuote.dataset.total;
if ( totalQuotes > 0 ) {
	document.querySelector( '.js-nb-quotes' ).innerHTML = totalQuotes;
	document.querySelector( '.js-nb-quotes' ).classList.add( 'display' );
}


// LOAD MORE
const loadMoreButton = document.querySelector( '.js-load-more-quotes' );
let isLoading = false;

if ( loadMoreButton ) {
	loadMoreButton.addEventListener( 'click', ( e ) => {

		if ( isLoading ) {
			return false;
		}

		isLoading = true;

		const parent = document.querySelector( '.study-quotes' );
		let lastQuote = parent.querySelectorAll( '.study-quotes__quote' );
		lastQuote = lastQuote[lastQuote.length - 1];

		const button = e.target;
		const action = button.dataset.action;
		const ajaxurl = button.dataset.ajaxurl;
		const nonce = button.dataset.nonce;
		const page = button.dataset.page;
		const studyID = button.dataset.study;
		const maxPage = button.dataset.max;

		const data = {
			action: action,
			nonce: nonce,
			page: page,
			studyid: studyID
		};

		const status = document.getElementById( 'js-quotes-status' );
		status.innerHTML = "Chargement en cours.";

		// Requête Ajax en JS natif via Fetch
		fetch( ajaxurl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Cache-Control': 'no-cache',
			},
			body: new URLSearchParams( data ),
		} )
			.then( response => response.json() )
			.then( body => {

				if ( body.success && body.data.html.length > 0 ) {
					button.dataset.page = body.data.page;

					lastQuote.insertAdjacentHTML( 'afterend', body.data.html );

					resizeAllGridItems();

					parent.querySelectorAll( '.study-quotes__quote.new' ).forEach( ( elt ) => {
						elt.classList.remove( 'new' );
					} );

					parent.querySelector( '#first-new-quote' ).scrollIntoView();
					parent.querySelector( '#first-new-quote' ).focus();
					parent.querySelector( '#first-new-quote' ).removeAttribute( 'id' );

					if ( body.data.page == maxPage ) {
						button.remove();
					}

					status.innerHTML = "";

				} else {
					status.innerHTML = "";
					status.innerHTML = "Les témoignages n'ont pas pu être chargés.";
				}

				isLoading = false;

			} );

	} );
}